import Base from '@studiometa/js-toolkit';
import withBreakpointObserver from '@studiometa/js-toolkit/decorators/withBreakpointObserver';

/**
 * StickyScroll class.
 */
export default class StickyScroll extends withBreakpointObserver(Base) {
  /**
   * Class cofnig
   * @return {Object}
   */
  static config = {
    name: 'StickyScroll',
    options: {
      inactiveBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
    refs: ['progress'],
  };

  /**
   * Mount StickyScroll
   * @return {void}
   */
  mounted() {
    this.calculateValues();
    this.updateProgressBar();
  }

  /**
   * Listening user scrolling on page
   * @return {void}
   */
  scrolled() {
    this.updateProgressBar();
  }

  /**
   * Listening window resizing
   * @return {void}
   */
  resized() {
    this.calculateValues();
    this.updateProgressBar();
  }

  /**
   * Update progress bar scale on scroll
   * @return {void}
   */
  updateProgressBar() {
    const wScrollY = window.scrollY;
    const scaleValue = wScrollY / this.bodyHeight;
    this.$refs.progress.style.transform = `scaleY(${scaleValue})`;
  }

  /**
   * Recalculate useful value for scrollbar
   * @return {void}
   */
  calculateValues() {
    this.bodyHeight = document.body.clientHeight - window.innerHeight;
  }
}
